export const CATEGORY_LABELS = {
  operations: 'Operations & Efficiency',
  customer: 'Customer Experience',
  marketing: 'Sales & Marketing',
  salesMarketing: 'Sales & Marketing',
  team: 'Team & Decision-Making'
};

export const formatCategoryLabel = (category = '') => {
  if (!category) return '';
  if (CATEGORY_LABELS[category]) return CATEGORY_LABELS[category];
  return String(category)
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/[-_]/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());
};
